import { closeAccordionsIn, closeQnaAccordionsIn } from './accordion';

const tabs = document.querySelectorAll('.tabs');

function initTabController() {
  tabs?.forEach(tab => {
    const tabButtons = tab.querySelectorAll(':scope > .tabs__btns .tab__btn');
    const tabInner = [...tab.querySelectorAll('.tabs__inner')].filter(
      inner => inner.closest('.tabs') === tab
    );

    if (!tabButtons.length || !tabInner.length) return;

    function centerActiveTab() {
      const btnsContainer = tab.querySelector(
        ':scope > .tabs__btns[data-center-tab]'
      );
      if (!btnsContainer) return;

      const activeBtn = btnsContainer.querySelector('.tab__btn.is-active');
      if (!activeBtn) return;

      const containerRect = btnsContainer.getBoundingClientRect();
      const btnRect = activeBtn.getBoundingClientRect();

      const offset =
        btnRect.left -
        containerRect.left -
        containerRect.width / 2 +
        btnRect.width / 2;

      btnsContainer.scrollBy({ left: offset, behavior: 'smooth' });
    }

    function restartVideos(container) {
      const videos = container.querySelectorAll('video');

      videos.forEach(video => {
        video.pause();
        video.currentTime = 0;

        const playPromise = video.play();

        if (playPromise instanceof Promise) {
          playPromise.catch(() => {});
        }
      });
    }

    // Інакше відео у прихованій вкладці продовжує декодуватись у фоні.
    function stopVideos(container) {
      container.querySelectorAll('video').forEach(video => {
        video.pause();
        delete video.dataset.pausedByViewport;
      });
    }

    function resetNestedTabs(parentContent) {
      const nestedTabs = parentContent.querySelectorAll('.tabs');

      nestedTabs.forEach(nestedTab => {
        const nestedButtons = nestedTab.querySelectorAll(
          ':scope > .tabs__btns .tab__btn'
        );

        // const nestedContent = nestedTab.querySelectorAll(
        //   ':scope > .tabs__inner'
        // );

        const nestedContent = [
          ...nestedTab.querySelectorAll('.tabs__inner'),
        ].filter(inner => inner.closest('.tabs') === nestedTab);

        if (!nestedButtons.length || !nestedContent.length) return;

        nestedButtons.forEach(btn => btn.classList.remove('is-active'));

        nestedContent.forEach(content =>
          content.classList.remove('is-active', 'is-visible')
        );

        const firstBtn = nestedButtons[0];
        const firstId = firstBtn.dataset.tab;
        const firstContent = nestedTab.querySelector(`#${firstId}`);

        firstBtn.classList.add('is-active');

        if (firstContent) {
          firstContent.classList.add('is-active', 'is-visible');
          restartVideos(firstContent);
        }
      });
    }

    function handleTabBtns(event) {
      const button = event.currentTarget;
      if (button.classList.contains('is-active')) return;

      const tabId = button.dataset.tab;

      tabButtons.forEach(btn => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      if (tabId === 'tb-all') {
        tabInner.forEach(content => {
          content.classList.add('is-active');
          requestAnimationFrame(() => content.classList.add('is-visible'));
        });
        centerActiveTab();
        return;
      }

      const targetTab = document.getElementById(tabId);
      if (!targetTab) return;

      tabInner.forEach(content => {
        content.classList.remove('is-active', 'is-visible');
        stopVideos(content);
      });

      closeAccordionsIn(tab);
      closeQnaAccordionsIn(tab);

      targetTab.classList.add('is-active');

      requestAnimationFrame(() => {
        targetTab.classList.add('is-visible');
        resetNestedTabs(targetTab);
        restartVideos(targetTab);
      });

      centerActiveTab();
    }

    function initActiveContent() {
      let activeBtn = tab.querySelector(
        ':scope > .tabs__btns .tab__btn.is-active'
      );

      if (!activeBtn) {
        activeBtn = tabButtons[0];
        activeBtn.classList.add('is-active');
      }

      const tabId = activeBtn.dataset.tab;

      tabInner.forEach(content =>
        content.classList.remove('is-active', 'is-visible')
      );

      if (tabId === 'tb-all') {
        tabInner.forEach(content =>
          content.classList.add('is-active', 'is-visible')
        );
        centerActiveTab();
        return;
      }

      const activeContent = document.getElementById(tabId);
      if (!activeContent) return;

      activeContent.classList.add('is-active', 'is-visible');
      restartVideos(activeContent);
      centerActiveTab();
    }

    initActiveContent();
    tabButtons.forEach(btn => btn.addEventListener('click', handleTabBtns));
  });
}

document.addEventListener('DOMContentLoaded', initTabController);

// <div class="tabs">
//   <div class="tabs__btns" data-center-tab>
//     <div>
//       <button type="button" class="tab__btn" data-tab="tb-block1">
//         block1
//       </button>
//       <button type="button" class="tab__btn" data-tab="tb-block2">
//         block2
//       </button>
//     </div>
//   </div>

//   <div class="tabs__inner" id="tb-block1"></div>
//   <div class="tabs__inner" id="tb-block2"></div>
// </div>
